import dzsSlideVerification from "./index.vue";

dzsSlideVerification.install = (Vue , options) =>{
    Vue.component(dzsSlideVerification.name, dzsSlideVerification)
}

export default dzsSlideVerification;